import { AuthenticationModule } from '../modules/authentication'
import { ActivationSubmitModule } from '../modules/checkout/activation/submit'
import { ErrorModule } from '../modules/error'
import { TransactionModule } from '../modules/Transaction'
import { CheckoutModule } from '@/store/modules/checkout'
import CheckoutPersonalDataModule from '@/store/modules/checkout/personalData'
import CheckoutMNPDataModule from '@/store/modules/checkout/mnpData'
import CheckoutPaymentModule from '@/store/modules/checkout/paymentData'
import { EmailConfirmationModule } from '@/store/modules/emailConfirmation'
import { ForgotPasswordModule } from '@/store/modules/forgotPassword'
import { ResetPasswordModule } from '@/store/modules/resetPassword'
import { FeedbackProcessModule } from '@/store/modules/feedbackProcess'
import { EvnModule } from '@/store/modules/evn'
import { ConsentModule } from '../modules/consent'
import { ChangePassword } from '@/store/modules/changePassword'
import { PersonalDataModule } from '@/store/modules/personalData'
import { ChangePaymentModule } from '@/store/modules/changePayment'
import { TariffOptionsModule } from '@/store/modules/tariffOptions'
import { TariffBreakModule } from '@/store/modules/changeTariff'
import { ContractSummaryModule } from '@/store/modules/contractSummary'
import { FeatureModule } from '@/store/modules/features'
import { BillsModule } from '@/store/modules/bills'
import { PromotionModule } from '@/store/modules/promotion'
import { PassivateSimCardModule } from '@/store/modules/passivateSimCard'
import SimCardDeviceDataModule from '@/store/modules/substituteSimCard/deviceData'
import { SubstituteSimCardModule } from '@/store/modules/substituteSimCard'
import { TerminationModule } from '@/store/modules/termination/'
import { CartModule } from '@/store/modules/cart/'
import { KWKModule } from '@/store/modules/kwk/'
import { ChristmasBannnerModule } from '@/store/modules/christmasBanner/'
import { SearchModule } from '@/store/modules/search'
import { esimPushModule } from '@/store/modules/esimPush'
import { ContractModule } from '@/store/modules/contract'
import CheckoutV2Module from '@/store/modules/checkoutv2'
import ABTestingModule from '@/store/modules/abTesting'
import { ModalsModule } from '@/store/modules/modals'
import MfaModule from '@/store/modules/mfa'

export const storeConfig = {
  modules: {
    Transaction: TransactionModule,
    authentication: AuthenticationModule,
    error: ErrorModule,
    checkout: CheckoutModule,
    personalData: CheckoutPersonalDataModule,
    resetPassword: ResetPasswordModule,
    forgotPassword: ForgotPasswordModule,
    contractSummary: ContractSummaryModule,
    mnpData: CheckoutMNPDataModule,
    payment: CheckoutPaymentModule,
    emailConfirmation: EmailConfirmationModule,
    feedbackProcess: FeedbackProcessModule,
    esimPush: esimPushModule,
    evn: EvnModule,
    changePassword: ChangePassword,
    consent: ConsentModule,
    personalDataChange: PersonalDataModule,
    tariffOptions: TariffOptionsModule,
    changePayment: ChangePaymentModule,
    tariffBreak: TariffBreakModule,
    activationSubmit: ActivationSubmitModule,
    feature: FeatureModule,
    bills: BillsModule,
    promotion: PromotionModule,
    lockSimCard: PassivateSimCardModule,
    substituteSimCard: SubstituteSimCardModule,
    deviceData: SimCardDeviceDataModule,
    termination: TerminationModule,
    cart: CartModule,
    kwk: KWKModule,
    christmasBanner: ChristmasBannnerModule,
    search: SearchModule,
    contract: ContractModule,
    checkoutv2: CheckoutV2Module,
    abTesting: ABTestingModule,
    modals: ModalsModule,
    mfa: MfaModule
  },
  actions: {
    clearState ({ commit }) {}
  }
}
